import { Action } from '@reduxjs/toolkit';
import { groupByActionTypes, StateWithHistory } from 'redux-undo';
import { v4 as uuidv4 } from 'uuid';

// See https://redux-undo.js.org/main/examples/undo-redo-batch-actions
// This allows grouping actions to be undone/redone at the same time
export const groupedUndo = {
  _group: null as null | string,
  batch(callable: Function, group = uuidv4()) {
    this._group = group;
    try {
      callable();
    } finally {
      this._group = null;
    }
  },
  // List of actions to automatically group
  init<RootState>(rawActions: Action['type'] | Action['type'][]) {
    const defaultGroupBy = groupByActionTypes(rawActions);
    return (action: Action, currentState: RootState, previousHistory: StateWithHistory<RootState>) => (
      this._group || defaultGroupBy(action, currentState, previousHistory)
    );
  }
};
